import { AMPLITUDE_USER_PROPS } from './statsConstants';
import { getUserLocalePreference } from '../users/utils/userPropertyUtils';

type UserWithLocalePreference = {
    settings?: {
        localePreference?: string | null;
    };
};

/**
 * Returns Amplitude user properties for a user's saved locale preference.
 */
export const getLocalizationPreferenceAmplitudeUserProperties = (
    user?: UserWithLocalePreference,
): Partial<Record<string, string>> => {
    const localePreference = getUserLocalePreference(user);
    if (!localePreference) return {};

    return {
        [AMPLITUDE_USER_PROPS.LOCALISATION_PREFERENCE]: localePreference,
    };
};
